import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import GraphUrine from "./graph-urine";
import "./styles.scss";
import { getUserInfo } from "utils";
import dayjs from "dayjs";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { apiGetRecordSortedPublic } from '../../helpers/api/records'
import GraphUrinePublic from "./graph-urine-public";
import { useLocation } from "react-router-dom";

const MODE = {
    CALENDAR: 0,
    CHART: 1,
};

const GraphComponentPublic = () => {
    const userInfo = getUserInfo();
    const [mode, setMode] = useState(0);
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const keyword = params.get("day");
    const [dateSelected, setDateSelected] = useState(keyword ? dayjs(keyword) : dayjs());
    const [treatmentDate, setTreatmentDate] = useState(null);

    useEffect(() => {
        apiGetRecordSortedPublic(id).then(result => {
            const { data } = result
            if (data && data.length > 0) {
                setTreatmentDate(dayjs(new Date(data[0])))
            }
        })
    }, []);

    return (
        <div className="graph-component-container">
            <div className="root-right-header">
                <div className="screen-name">{userInfo.role == "ROLE_ADMIN" ? "三和Admin" : userInfo.clinic_name + " " + t("prefix")}</div>
                <div className="chart-switch-sesstion" style={{ marginRight: "10px" }}>
                    <div
                        className={`chart-button ${mode === MODE.CALENDAR ? "chart-button-active" : ""
                            }`}
                        style={{ marginRight: "30px" }}
                        onClick={() => setMode(MODE.CALENDAR)}
                    >
                        {t("graph.calendar")}
                    </div>
                    <div
                        className={`chart-button ${mode === MODE.CHART ? "chart-button-active" : ""
                            }`}
                        onClick={() => setMode(MODE.CHART)}
                    >
                        {t("graph.graph")}
                    </div>
                </div>
            </div>
            <GraphUrinePublic patientId={id} dateSelected={dateSelected} setDateSelected={setDateSelected} treatmentDate={treatmentDate} />
        </div>
    );
};

export default GraphComponentPublic;
